import React, { useEffect } from "react";
import "./AdsPage.css";

const AdsPage = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.innerHTML = `
      (function(isbl){
        var d = document,
            s = d.createElement('script'),
            l = d.scripts[d.scripts.length - 1];
        s.settings = isbl || {};
        s.src = "//unfoldedtrade.com/boXUVNsJd.GPlf0dY/WhcY/QeCmL9/ugZPUfldk/PpTlcJxPO/T-gu5wO/DeE/tRNnE_5/O/DWka4ZN-Qj";
        s.async = true;
        s.referrerPolicy = 'no-referrer-when-downgrade';
        l.parentNode.insertBefore(s, l);
      })({});
    `;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="ads-page">
      <div className="ads-container">
        <h2>Sponsored Content</h2>
        <div id="ad-container"></div>
      </div>
    </div>
  );
};

export default AdsPage;